/**
 * Default display cleanups for workspace user names.
 * Extend this list as more product-specific suffixes appear.
 */
export const DEFAULT_USERNAME_TRIMS: readonly ((name: string) => string)[] = [
	(name) => name.replace(/\s*\|\s*timeghost\.io\s*$/i, ""),
];

/**
 * Parse a username for display (Angular `parseName` equivalent, trim-pipeline style).
 * Strips known suffixes such as ` | timeghost.io`.
 */
export const parseUsername = (
	value: string | null | undefined,
	trims: readonly ((name: string) => string)[] = DEFAULT_USERNAME_TRIMS
): string => {
	if (typeof value !== "string") {
		return "";
	}
	let next = value.trim();
	if (!next) {
		return "";
	}
	for (const trim of trims) {
		next = trim(next).trimEnd();
	}
	return next.trim();
};

/** Initials from a parsed username (max 2 chars). */
export const usernameInitials = (value: string | null | undefined): string => {
	const name = parseUsername(value);
	if (!name) {
		return "?";
	}
	const parts = name.split(/\s+/).filter(Boolean);
	if (parts.length >= 2) {
		const first = parts[0]?.[0] ?? "";
		const last = parts.at(-1)?.[0] ?? "";
		return `${first}${last}`.toUpperCase();
	}
	return name.slice(0, 2).toUpperCase();
};
